<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    @if (isTaxOwnerDataPresent) {
<div class="section-block">
      <div class="text-center section-header" (click)="taxOwnerCollapsed=!taxOwnerCollapsed">
        <a href="javascript:void(0)" style="color:#fff;">Current Tax Owner Information</a>
      </div>
      <br>
      @if (taxOwnerCollapsed) {
<div>
        <table class="table table-bordered custom-table">
          <thead>
            <tr>
              <th rowspan="2">Current Tax Owner LEID</th>
              <th rowspan="2">Name and address</th>
              <th rowspan="2">Annual accounting period covered by the return</th>
              <th rowspan="2">U.S. identifying number, if any</th>
              <th rowspan="2">Reference ID number</th>
              <th rowspan="2">Country under whose laws organized</th>
              <th rowspan="2">Functional currency</th>
            </tr>
          </thead>
          <tbody>
            @for (item of taxOwnerObj; track $index) {
<tr>
              <td>{{ item['8858_NA_TAX_OWNER_LEID'] }}</td>
              <td>
                <div class="addr-line">{{ item['8858_NA_TAX_OWNER_NAME_1'] }} {{ item['8858_NA_TAX_OWNER_NAME_2'] }}</div>
                <div class="addr-line">{{ item['8858_NA_TAX_OWNER_US_COUNTRY'] === 'US' ? item['8858_NA_TAX_OWNER_US_ADDR_1'] : item['8858_NA_TAX_OWNER_F_ADDR_1'] }}</div>
                <div class="addr-line">{{ item['8858_NA_TAX_OWNER_US_COUNTRY'] === 'US' ? item['8858_NA_TAX_OWNER_US_ADDR_2'] : item['8858_NA_TAX_OWNER_F_ADDR_2'] }} {{ item['8858_NA_TAX_OWNER_US_COUNTRY'] === 'US' ? item['8858_NA_TAX_OWNER_US_CITY'] : item['8858_NA_TAX_OWNER_F_CITY'] }}</div>
                <div class="addr-line">{{ item['8858_NA_TAX_OWNER_US_STATE'] || item['8858_NA_TAX_OWNER_F_STATE'] }}</div>
                <div class="addr-line">{{ item['8858_NA_TAX_OWNER_US_COUNTRY'] === 'US' ? item['8858_NA_TAX_OWNER_US_ZIP'] : item['8858_NA_TAX_OWNER_F_ZIP'] }}</div>
                <div class="addr-line">{{ item['8858_NA_TAX_OWNER_US_COUNTRY'] === 'US' ? '' : item['8858_NA_TAX_OWNER_F_COUNTRY'] }}</div>
              </td>
              <td>{{ item['8858_NA_TAX_OWNER_BEGIN_DATE'] }} - {{ item['8858_NA_TAX_OWNER_END_DATE'] }}</td>
              <td>{{ item['8858_NA_TAX_OWNER_EIN'] ? item['8858_NA_TAX_OWNER_EIN'] : item['8858_NA_TAX_OWNER_EIN_MISSING_REASON'] }}</td>
              <td>{{ item['8858_NA_TAX_OWNER_REFERENCE_ID'] }}</td>
              <td>{{ item['8858_NA_TAX_OWNER_COUNTRY_LAWS'] }}</td>
              <td>{{ item['8858_NA_TAX_OWNER_FUNC_CURRENCY'] }}</td>
            </tr>
}
          </tbody>
        </table>
      </div>
}
    </div>
}

    <div class="form-group form-group-row">
      <label class="control-label">Update Existing Tax Owner</label>
      @if ((taxOwnerList?.values?.length ?? 0) > 0) {
<div class="select-wrap">
        <div df-select-single
             [filter]="taxOwnerList"
             (filterChange)="onTaxOwnerFilterChange()">
        </div>
      </div>
}
    </div>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save_tax_owner()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
